// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const {
  setInitialised,
  useArrows,
  addWheelControls,
} = window.BAO.Carousel.plugins

class CollectionHeroCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
    document.body.classList.add('lyt-HeroCarousel')
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'free',
        renderMode: 'performance',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 1.47,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.9,
            },
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 6,
            },
          },
          '(min-width: 1700px)': {
            slides: {
              perView: 7.1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('collection-hero-carousel')) {
  customElements.define('collection-hero-carousel', CollectionHeroCarousel)
}
